import React from 'react';
import Typewriter from 'typewriter-effect';
import { motion } from 'framer-motion';

export default function Header() {
  return (
    <header>
    <motion.div
    className="glass"
    initial={{ y: -30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.6 }}
    style={{ textAlign: 'center' }}
    >
    <h1>
    <Typewriter
    options={{
      strings: ['Welcome to Copicraft', 'Your orange-lit hacker playground'],
      autoStart: true,
      loop: true,
      pauseFor: 2000,
    }}
    />
    </h1>
    <p>
    A1-powered tinkerer: Python & GodotSkript dev, ESP32 & PCB architect, smart-home innovator, AI-assisted Java coder, Arch Linux guru, DHCP network designer, and hand-soldering ace.
    </p>
    </motion.div>
    <nav aria-label="Main navigation">
    <ul>
    {['programming', 'ai', 'modding', 'electronics', 'smarthome', 'arch', 'selfhosting'].map(id => (
      <li key={id}>
      <a href={`#${id}`}>{id.charAt(0).toUpperCase() + id.slice(1)}</a>
      </li>
    ))}
    </ul>
    </nav>
    </header>
  );
}
